/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import React from 'react';
import { handleArrowKeydown } from '../utils/carousel-helpers';

const CarouselPreviousArrow = ({ onClick }) => {
  return (
    <div
      alt="carousel-previous-arrow"
      onClick={onClick}
      onKeyDown={e => handleArrowKeydown(e, onClick)}
      className="carousel-previous-arrow"
      role="button"
      tabIndex={0}
      aria-label="previous item button"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Previous Location Arrow</title>
        <circle
          r="12"
          transform="matrix(-1 0 0 1 12 12)"
          fill={'var(--primary-brand-font-color)'}
        />
        <path
          d="M12 0C18.6268 0 24 5.37321 24 12C24 18.6268 18.6268 24 12 24C5.37321 24 0 18.6268 0 12C0 5.37321 5.37321 0 12 0ZM7.85625 12.1741L14.4455 16.942C14.5875 17.0438 14.7857 16.942 14.7857 16.7679V15.5116C14.7857 15.2384 14.6545 14.9786 14.4321 14.8179L10.5375 12L14.4321 9.18214C14.6545 9.02143 14.7857 8.76429 14.7857 8.48839V7.23214C14.7857 7.05804 14.5875 6.95625 14.4455 7.05804L7.85625 11.8259C7.73839 11.9116 7.73839 12.0884 7.85625 12.1741Z"
          fill={'var(--primary-brand-color)'}
        />
      </svg>
    </div>
  );
};

export default React.memo(CarouselPreviousArrow);
